enum FormState {
  LOG_IN,
  LOGGING_IN,
  SELECT_PRACTICES,
  CREATING_ACCOUNTS,
  ACCOUNTS_CREATED
}

export default FormState;
